module.exports = "/_next/static/videos/isra-social-4581d7fe7a5847c7829592f754507489.mp4";